import { gql } from '@apollo/client';

export const GET_TIERS = gql`
  query GetTiers {
    tiers {
      _id
      name
      description
      monthlyFee
      monthlyCredits
      pricePerAdditionalCredit
      maxCreditsAllowed
      isFree
      features
    }
  }
`;

export const GET_MY_SUBSCRIPTION = gql`
  query GetMySubscription {
    mySubscription {
      _id
      tier {
        _id
        name
        monthlyCredits
        maxCreditsAllowed
        pricePerAdditionalCredit
      }
      status
      currentPeriodStart
      currentPeriodEnd
      cancelAtPeriodEnd
      pendingTierId
      pendingTier {
        _id
        name
        monthlyCredits
        maxCreditsAllowed
      }
      pendingTierChangeDate
      paymentFailedAt
      paymentGracePeriodEnds
      createdAt
    }
  }
`;

export const GET_CLIENT = gql`
  query GetClient {
    getClient {
      _id
      company
      credits
      periodCreditsUsed
      totalCredits
      currentTier {
        _id
        name
        monthlyCredits
        maxCreditsAllowed
      }
      subscriptionStatus
      creditsExpireAt
    }
  }
`;

export const VERIFY_CHECKOUT_SESSION = gql`
  query VerifyCheckoutSession($sessionId: String!) {
    verifyCheckoutSession(sessionId: $sessionId) {
      status
      paymentStatus
      subscriptionId
      tierId
    }
  }
`;
